module.exports = __webpack_public_path__ + "img/message.9340ff3b.svg";